export const isFunction = (arg: any): arg is Function => typeof arg === 'function'
